// Clipboard helpers shared by the ERB pages (erbCopy.js) and the SPA.

export const copyText = (text: string): Promise<void> => navigator.clipboard.writeText(text);

// Copies what `path` serves. Safari only honours a clipboard write that starts
// inside the click, so where ClipboardItem takes a promise the write starts now
// and the text follows; elsewhere (or if that is refused) the text is fetched
// first, which Chrome and Firefox allow within the click's activation window.
export const copyFetchedText = async (path: string): Promise<void> => {
  const text = fetch(path, { credentials: "same-origin" }).then((res) => {
    if (!res.ok) throw new Error(`GET ${path}: ${res.status}`);
    return res.text();
  });

  if (typeof ClipboardItem !== "undefined" && navigator.clipboard.write) {
    try {
      const blob = text.then((body) => new Blob([body], { type: "text/plain" }));
      await navigator.clipboard.write([new ClipboardItem({ "text/plain": blob })]);
      return;
    } catch {
      // Fall through to a plain write.
    }
  }
  await navigator.clipboard.writeText(await text);
};
